import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl as FormControl, UntypedFormGroup as FormGroup, Validators } from '@angular/forms';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { DocumentTemplateDetails, TemplateField, TemplateFieldMode, TemplateFieldType } from '../../document-template-administration-model';

@Component({
    selector: 'app-template-field-details',
    templateUrl: './template-field-details.component.html',
    styleUrls: ['./template-field-details.component.scss'],
    standalone: false
})
export class TemplateFieldDetailsComponent {

  showDefaultValue = true;
  showSelectDefinitionsSelection = false;

  modeOptions = new Array<TemplateFieldMode>();
  typeOptions = new Array<TemplateFieldType>();

  details: TemplateField = new TemplateField();
  templateDetails: DocumentTemplateDetails;

  detailsFormGroup: FormGroup;

  @Output() deleteTemplateField = new EventEmitter<TemplateField>();

  @Input() set templateField(templateField: TemplateField) {
    this.details = templateField;
    this.initForm();
  }

  @Input() set template(template: DocumentTemplateDetails) {
    this.templateDetails = template;
    this.initForm();
  }

  constructor(
    public translationService: TranslationService) {
    this.initializeDetailsForm();
  }

  private initializeDetailsForm() {

    for (const key of Object.keys(TemplateFieldMode)) {
      this.modeOptions.push(TemplateFieldMode[key]);
    }

    for (const key of Object.keys(TemplateFieldType)) {
      this.typeOptions.push(TemplateFieldType[key]);
    }

    this.detailsFormGroup = new FormGroup({
      defaultValue: new FormControl('', []),
      key: new FormControl('', [Validators.required]),
      required: new FormControl('', []),
      mode: new FormControl('', [Validators.required]),
      type: new FormControl('', [Validators.required]),
      selectDefinitionUuid: new FormControl('', [])
    });

    this.detailsFormGroup.valueChanges.subscribe(
      values => {
        if (this.detailsFormGroup.dirty) {
          const v = this.detailsFormGroup.getRawValue();
          this.details.defaultValue = v.defaultValue;
          this.details.key = v.key;
          this.details.key = v.key;
          this.details.required = v.required;
          this.details.mode = v.mode;
          this.details.type = v.type;
          this.details.selectDefinitionUuid = v.selectDefinitionUuid;
          this.updateFieldVisibility();
          this.templateDetails.dirty = true;
          this.templateDetails.validate();
        }
      }
    );
  }

  public onDataDictionaryChanged(dictionaryEntry: DictionaryEntry) {
    // Object neu erzeugen damit change detection und somit überstzungspipe reagieren
    this.details.label = new DictionaryEntry(dictionaryEntry);
    this.templateDetails.dirty = true;
    this.templateDetails.validate();
  }

  public deleteField() {
    this.deleteTemplateField.next(this.details);
  }

  private updateFieldVisibility() {
    this.showDefaultValue = this.details.type !== TemplateFieldType.SELECT;
    this.showSelectDefinitionsSelection = this.templateDetails != null && this.details.type === TemplateFieldType.SELECT;
  }

  private initForm() {
    if (this.details != null && this.templateDetails != null) {
      const values = {
        defaultValue: this.details.defaultValue,
        key: this.details.key,
        required: this.details.required,
        mode: this.details.mode,
        type: this.details.type,
        selectDefinitionUuid: this.details.selectDefinitionUuid
      };
      this.detailsFormGroup.reset(values);
      this.updateFieldVisibility();
    }
  }
}
